"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBrandMapsResponseAllOfToJSON = exports.GetBrandMapsResponseAllOfFromJSONTyped = exports.GetBrandMapsResponseAllOfFromJSON = void 0;
var _1 = require("./");
function GetBrandMapsResponseAllOfFromJSON(json) {
    return GetBrandMapsResponseAllOfFromJSONTyped(json, false);
}
exports.GetBrandMapsResponseAllOfFromJSON = GetBrandMapsResponseAllOfFromJSON;
function GetBrandMapsResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'brandMaps': (json['brandMaps'].map(_1.BrandMapFromJSON)),
    };
}
exports.GetBrandMapsResponseAllOfFromJSONTyped = GetBrandMapsResponseAllOfFromJSONTyped;
function GetBrandMapsResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'brandMaps': (value.brandMaps.map(_1.BrandMapToJSON)),
    };
}
exports.GetBrandMapsResponseAllOfToJSON = GetBrandMapsResponseAllOfToJSON;
